<template>
  <div class="tw-cursor-pointer tw-overflow-hidden"
       @click="toggle()"
       :style="['width:' + size + 'px']">
    <transition name="checkbox">
      <BaseIcon
        v-if="internalValue"
        key="checked"
        icon="check-box-bold"
        :size="size"
        class="tw-text-primary-500"
      />
      <BaseIcon
        v-else
        key="unchecked"
        icon="check-box-outline"
        :size="size"
        class="tw-text-gray-500"
      />
    </transition>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, getCurrentInstance } from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  size: { type: [String, Number], default: 24 },
  byConform: { type: Boolean, default: true },
  disableConfirmTitle: { type: String, default: null },
  disableConfirmText: { type: String, default: null },
  enableConfirmTitle: { type: String, default: null },
  enableConfirmText: { type: String, default: null },
});

const emit = defineEmits(["update:modelValue"]);

const proxy = getCurrentInstance().proxy;

const internalValue = ref(props.modelValue);
const skipWatch = ref(false);

watch(
  () => props.modelValue,
  (newVal, oldVal) => {

    if(props.byConform) {
      if (skipWatch.value) {
        skipWatch.value = false;
        internalValue.value = newVal;
        return;
      }

      const confirmConfig = newVal
        ? {
          confirm_text: "تایید",
          confirm_icon: "check-circle",
          title: props.enableConfirmTitle || "تایید فعال سازی",
          text:
            props.enableConfirmText ||
            "آیا از فعال سازی این گزینه مطمئن هستید؟",
          icon: 'circle-check'
        }
        : {
          confirm_text: "تایید",
          confirm_icon: "check-circle",
          title: props.disableConfirmTitle || "تایید غیرفعال سازی",
          text:
            props.disableConfirmText ||
            "آیا از غیر فعال سازی این گزینه مطمئن هستید؟",
        };

      proxy.$showConfirm(confirmConfig, () => {
        internalValue.value = newVal;
      }, () => {
        skipWatch.value = true;
        emit("update:modelValue", oldVal);
      });

    } else {
      internalValue.value = newVal;
    }


  }
);

const toggle = () => {
  const newValue = !internalValue.value;
  emit("update:modelValue", newValue);
};

</script>

<style scoped>
.checkbox-enter-active,
.checkbox-leave-active {
  transition: all 0.2s ease;
}

.checkbox-enter-from,
.checkbox-leave-to {
  transform: scale(0.6);
  opacity: 0;
}

.checkbox-enter-to,
.checkbox-leave-from {
  transform: scale(1);
  opacity: 1;
}
</style>
